import { Timestamp } from '@marmon/shared/types/common';

type TimestampLike =
	| Timestamp
	| Date
	| { seconds: number; nanoseconds?: number }
	| { _seconds: number; _nanoseconds?: number };

function hasToDate(
	value: TimestampLike,
): value is Timestamp & { toDate: () => Date } {
	return (
		typeof value === 'object' &&
		value !== null &&
		'toDate' in value &&
		typeof value.toDate === 'function'
	);
}

export function timestampToDate(value: TimestampLike): Date {
	if (value instanceof Date) return value;
	if (hasToDate(value)) return value.toDate();

	if ('seconds' in value && typeof value.seconds === 'number') {
		return new Date(value.seconds * 1000);
	}

	if ('_seconds' in value && typeof value._seconds === 'number') {
		return new Date(value._seconds * 1000);
	}

	throw new Error('Unsupported timestamp value');
}

export function timestampToIsoDate(value: TimestampLike): string {
	return timestampToDate(value).toISOString().slice(0, 10);
}

export function timestampToIso(value: TimestampLike): string {
	return timestampToDate(value).toISOString();
}
